export enum EFulfillmentMode {
  Combined = 0,
  Separated = 1,
}
